// extracted by mini-css-extract-plugin
module.exports = {"body":"University_body__2UXz7","content":"University_content__lOMi2","text":"University_text__oB4m2","image":"University_image__S4IDx"};